import ImportImages from '@src/importImages';

const AlexWilcox = ImportImages('/leadership/Alex_Wilcox.jpg');
const Stephanie = ImportImages('/leadership/Stephanie.jpg');
// const Artur = ImportImages('/leadership/Arthur_Samberg.png');
// const James = ImportImages('/leadership/James_Hnat.jpg');
const Giles = ImportImages('/leadership/giles-agutter.jpg');
// const Tony = ImportImages('/leadership/Tony_Hsieh.png');
const Qatar = ImportImages('/leadership/QATAR_Logo.png');
const Sunil = ImportImages('/leadership/Sunil.jpeg');
// const Alicia = ImportImages('/leadership/Alicia.jpg');
const Kevin = ImportImages('/leadership/Kevin.jpg');
const Thomas = ImportImages('/leadership/thomas_fry.jpg');
const Linda = ImportImages('/leadership/linda.png');
const Anaselia = ImportImages('/leadership/anaselia.jpg');
const JetBlue = ImportImages('/leadership/jetblue.png');
const JamesJensen = ImportImages('/leadership/JamesJensen.png');
const EricDufay = ImportImages('/leadership/EricDuffay.png');
const ScottMusselwhite = ImportImages(
  '/leadership/Scott-Musselwhite-Headshot-1.jpg'
);
const BryanBelknap = ImportImages('/leadership/Bryan-Belknap-Headshot-1.jpg');
const JeffSamberg = ImportImages('/leadership/jeff-samberg.jpg');
const MillieChou = ImportImages('/leadership/millie-chou.jpg');
const TracyLawlor = ImportImages('/leadership/tracy-lawlor.jpg');
export const leadershipData = [
  {
    id: 1,
    name: 'Alex Wilcox',
    role: 'CEO/Co-Founder/Board Member',
    avatar: AlexWilcox,
    description:
      'With over two decades of experience in creating highly innovative air carriers in ways that have improved air' +
      ' travel for millions, Alex Wilcox now serves as CEO of JetSuite — a private jet airline which launched' +
      ' operations in 2009. In co-founding JetSuite in 2008, Alex brought new technology and unprecedented value' +
      ' to an industry in dire need of it. JetSuite is a launch customer for the Embraer Phenom 100, an airplane' +
      ' twice as efficient and more comfortable than other jets performing its missions. Also a founder of' +
      ' JetBlue, Alex was a driving force behind many airline industry-changing innovations, including the' +
      ' implementation of LiveTV on board and all leather coach seating. A graduate of University of Vermont, Alex' +
      ' was named a Henry Crown Fellow by the Aspen Institute and is a member of the Lone Star chapter of Young' +
      ' Presidents Organization (YPO).'
  },
  {
    id: 2,
    name: 'Stephanie Chung',
    role: 'PRESIDENT',
    avatar: Stephanie,
    description:
      'Stephanie Chung joined JetSuite as a 30-year veteran of the commercial and business aviation industry. Over' +
      ' the course of her career, Chung has become an expert at training individuals and Fortune 500 companies' +
      ' around the world as an award-winning executive coach, sales mentor, and business advisor. In addition to' +
      ' coaching some of the most elite sales teams in the country using advanced neuroscience selling strategies,' +
      ' she also served as former VP of Sales (Western Region) at Flexjet and in various executive roles at' +
      ' Skyjet. Chung is also the author of Profit Like a Girl and A Woman’s Guide to Kicking-Butt in Sales and' +
      ' Leadership, and the creator of the Neuroscience Selling collection and the High Ticket Selling Made Simple' +
      ' course.'
  },
  {
    id: 4,
    name: 'Sunil Ramchandani',
    role: 'CFO',
    avatar: Sunil,
    description:
      'As Chief Financial Officer at JetSuite, Sunil Ramchandani is responsible for all aspects of JetSuite’s' +
      ' financial disciplines. He brings with him over fifteen years of progressive experience in financial' +
      ' management, sales, e-commerce, and operations. Prior to joining JetSuite, Sunil worked with startups and' +
      ' multi-billion dollar companies, including General Motors and John Hancock Financial Services. With' +
      ' extensive experience raising capital, Sunil has led multiply equity and debt financings and played pivotal' +
      ' roles in several M&A activities. Raised and educated in Montreal, Canada, Sunil holds both a Bachelor in' +
      ' Mechanical Engineering and an MBA in Finance from McGill University.'
  },
  {
    id: 6,
    name: 'Kevin Horan',
    role: 'VP, CORPORATE SOUL',
    avatar: Kevin,
    description:
      'As the Vice President of Corporate Soul, Kevin Horan leads JetSuite and JetSuiteX’s Human Resources team' +
      ' focused on supporting its crew members. With more than thirty years of experience in aviation, he has held' +
      ' positions in both operations and human resources for regional, national, and international carriers' +
      ' including Pan American World Airways, People Express Airlines, American Airlines/American Eagle, and US' +
      ' Airways. In addition to working directly with carriers, Kevin has served as an advisor on Human Capital' +
      ' consulting projects for international organizations going through significant restructuring and M&A' +
      ' activities. A world traveler, Kevin has lived and worked in the Americas, EMEA, AsiaPac and Australia and' +
      ' New Zealand. Kevin has a B.A. from Davidson College and an MBA, International HR Concentration from the' +
      ' University of Dallas.'
  },
  {
    id: 7,
    name: 'Thomas Fry',
    role: 'Director of Marketing',
    avatar: Thomas,
    description:
      'As Director of Marketing at JetSuite, Thomas Fry is responsible for all aspects of Marketing,' +
      ' Branding, and Public Relations. He brings with him over ten years of private aviation experience both on' +
      ' the brand and agency side of the business. Prior to joining JetSuite, Thomas worked with global business' +
      ' aviation leader, VistaJet, in launching their U.S. operations, seeing that market rise to number one in' +
      ' revenue for the company within three years, as well as representing one of the world’s largest business' +
      ' aviation manufacturers, Bombardier, for six years in Entertainment Marketing and Sales. Raised in North' +
      ' Carolina, and educated in Virginia, Thomas holds a BA in Western Political Thought from Randolph-Macon' +
      ' College and a JD from George Mason University School of Law. His favorite places to travel are the beaches' +
      ' of North Carolina and London, both to spend time with family.'
  },
  {
    id: 8,
    name: 'Linda MacAskill',
    role: 'Director of Mission Control',
    avatar: Linda,
    description:
      'With over thirty years of experience in Customer Service and Operations, Linda MacAskill’s career' +
      ' in aviation started in Montreal, Canada in Customer Support, before finding her true passion in' +
      ' Operations. Graduating with a degree in computer science from McGill University, Linda has since been' +
      ' recognized in the Leadership in Action Program’s Annual Report of Former Employers for leading and' +
      ' implementing a project that seamlessly transformed the customer experience.'
  },
  {
    id: 9,
    name: 'Anaselia Galli',
    role: 'Director of Guest Services',
    avatar: Anaselia,
    description:
      'Anaselia runs the Guest Services and Account Management Program at JetSuite. Growing up in the San' +
      ' Francisco Bay Area and studying musical theatre at UC Irvine, she uses her theatrical background much more' +
      " than she ever anticipated in the private aviation space. She's been with JetSuite since 2012 and has" +
      " enjoyed every minute of growing up with this company. When she's not working with SuiteKey members and" +
      ' her amazing team, you can find her checking out live music, drinking a good glass of wine, or exploring' +
      ' her new city of Dallas, Texas.'
  },
  {
    id: 10,
    name: 'James Jensen',
    role: 'Director of Operations',
    avatar: JamesJensen,
    description:
      'With extensive experience in government oversight and contracting - combined with his background as an Airline Transport Pilot and Flight Instructor - James Jensen joined JetSuite as a veteran of commercial flight. Having worked for high-wealth FAR part 91 flight departments, this experience extends to FAR part 135 and FAR part 91 training, program development and compliance. With over 25 years in aviation, James’ business development across air carrier operations, volunteer organizations and government contracting have resulted in an increase in fleet size, growth in entity income and an expansion of membership and employee bases.'
  },
  {
    id: 11,
    name: 'Eric Dufay',
    role: 'Director of Charter Sales',
    avatar: EricDufay,
    description:
      'Growing up in an aviation family, Eric jumped into the airline world through his work for a charter company specializing in sports travel. After spending 8 years flying around the world with professional and college teams - followed by experience with large California and Colorado based charter companies - Eric joined JetSuite in 2015, bringing along his strong roots and passion for flight.'
  },
  {
    id: 12,
    name: 'Scott Musselwhite',
    role: 'Senior Director and Head of Sales',
    avatar: ScottMusselwhite,
    description:
      'As Senior Director and Head of Sales, Scott is responsible for strategic oversight of JetSuite’s membership sales strategy and nationwide sales team. Scott redirected an early career in banking and small business ownership to pursue a lifelong passion for aviation, professionally. Managing front-line, FBO and charter services before joining JetSuite, Scott brings over a decade of professional, industry experience, and twenty years of recreational involvement in general aviation. This experience forged a clear and comprehensive understanding of what on-demand travelers seek when flying private. Scott has a degree in Aeronautics from Embry-Riddle Aeronautical University. Outside of work, he enjoys the outdoors, weekend adventures with his wife and three children, and recently, he returned to the cockpit as a recreational student, continuing his passionate pursuit of flight.'
  },
  {
    id: 13,
    name: 'Bryan Belknap',
    role: 'Director of Maintenance',
    avatar: BryanBelknap,
    description:
      'Bryan Belknap has worked for over 25 years in Aviation Maintenance. Dedicated to flight from an early age - with cutaway drawings and old maintenance manuals always at hand - it only took one hour in a Learjet 30 series simulator to inspire Bryan towards a career in aviation. From consulting in the founding of a Part 141 flight school and developing a Part 145 Certified Repair Station, to now managing the Part 135 Certificate of JetSuite, his experience in maintenance is extensive and diverse. Always looking skyward to see what’s flying overhead, Bryan’s commitment to aviation is unwavering.'
  },

  /*{
      id: 10,
      name: 'Tony Hsieh',
      role: 'CEO, ZAPPOS.com',
      avatar: Tony,
      description:
        'Tony Hsieh is an entrepreneur and business innovator with an impressive track record of success. Tsieh' +
        ' co-founded LinkExchange, and at the age of 24 sold it to Microsoft for $265 million. He then joined' +
        ' Zappos.com as an advisor and investor, eventually became CEO, and helped grow the company to over $1' +
        ' billion in sales annually, while making Fortune Magazine’s annual ‘Best Companies to Work For’ list. In' +
        ' 2009, Zappos.com, Inc. was acquired by Amazon.com in a deal valued at $1.2 billion. Today, Tsieh is the' +
        ' bestselling author of <i>Delivering Happiness</i>, and is leading the charge to reinvent downtown Las Vegas.'
    },
    {
      id: 11,
      name: 'Art Samberg',
      role: 'CHAIRMAN',
      avatar: Artur,
      description:
        'After twenty years on Wall Street following technology stocks, Art founded Pequot Partners in 1986. From an' +
        ' initial $3 million, by 2000 the hedge fund had grown to over $17 billion, making it the largest in the' +
        ' world. In 2009, Samberg closed Pequot and established Hawkes Financial Services. In addition to his role' +
        ' as JetSuite’s Chairman of the Board, Samberg also serves as Co-chair of Columbia Business School and' +
        ' serves on the Executive Committee of MIT and the New York Presbyterian Hospital.'
    },
    {
      id: 12,
      name: 'James Hnat',
      role:
        'EVP, CORPORATE AFFAIRS, GENERAL COUNSEL & CORPORATE SECRETARY, JETBLUE AIRWAYS',
      avatar: James,
      description:
        'As Executive President, General Counsel, and Corporate Secretary of JetBlue Airways Corporation, James Hnat' +
        ' oversees legal, government and airport affairs, as well as compliance, sustainability, cyber security and' +
        ' the aircraft delivery program. As an aviation attorney, Hnat’s practice areas include international' +
        ' aviation treaties, aircraft finance, manufacturer contracts, governance, privacy, litigation, aviation' +
        ' safety and security, regulatory and compliance matters. Hnat is also a member of the bar in New York and' +
        ' Massachusetts and is admitted to practice in the US District Court for the Southern District of New York,' +
        ' the US District Court for the Eastern District of New York, the US Court of Appeals for the Second' +
        ' Circuit, the US Court of Appeals for the Fourth Circuit and the United States Supreme Court.'
    },
    {
      id: 13,
      name: 'Giles Agutter',
      role: 'OWNER AND CHIEF EXECUTIVE OFFICER OF SOUTHERN SKY LTD',
      avatar: Giles,
      description:
        'Giles Agutter is the owner and Chief Executive Officer of Southern Sky Ltd, an airline consultant company' +
        ' specializing in airline strategy, fleet planning, aircraft acquisition and aircraft financing. Agutter' +
        ' earned his degree in Aerospace Engineering from Manchester University and has vast experience in advising' +
        ' airlines--including Qatar Airways--on significant Merger and Acquisition projects within the airline' +
        ' industry.'
    },*/
  {
    id: 14,
    name: 'JetBlue',
    role: 'INVESTOR',
    avatar: JetBlue,
    description:
      'JetBlue, the sixth largest airline in the United States, is a minority stake investor in JetSuite. JetBlue is' +
      ' headquartered in the Long Island City neighborhood of the New York City borough of Queens, with its main' +
      ' base at John F. Kennedy International Airport. As of June 2017, JetBlue serves 101 destinations in the' +
      ' U.S., Mexico, the Caribbean, Central America and South America.'
  },
  {
    id: 15,
    name: 'QATAR AIRWAYS',
    role: 'INVESTOR',
    avatar: Qatar,
    description:
      'Qatar Airlines, the national carrier of the State of Qatar, became a JetSuite stakeholder in early 2018.' +
      ' Qatar Airlines is the world’s fastest-growing airline and was named “Airline of the Year” by the 2017' +
      ' World Airline Awards, in addition to accolades such as “World’s Best Business Class,” “Best Airline in the' +
      ' Middle East,” and “World’s Best First Class Airline Lounge.” Qatar Airlines is proud of its 20+ year' +
      ' legacy of transporting travellers to more than 150 business and leisure destination on its modern fleet of' +
      ' 200+ aircraft.'
  },
  // NEw
  {
    id: 19,
    name: 'Tracy Lawlor',
    role: 'Chair of the Board',
    avatar: TracyLawlor,
    description:
      'Tracy Lawlor is JetBlue’s Vice President of Strategy & Business Development. She directly supports Robin' +
      ' Hayes, JetBlue’s Chief Executive Officer, by leading the development and execution of the enterprise-wide' +
      ' strategy. Tracy has held multiple leadership positions within JetBlue over her 18 year tenure, most' +
      ' recently as the Vice President of Financial Planning & Analysis. She is excited to join the JetSuite Board' +
      ' to help the company achieve its long-term vision by leveraging her experience in developing successful' +
      ' corporate strategies and driving exceptional transformation through strategic engagements.'
  },
  {
    id: 17,
    name: 'Giles Agutter',
    role: 'BOARD MEMBER',
    avatar: Giles,
    description:
      'Giles Agutter is the owner and Chief Executive Officer of Southern Sky Ltd, an airline consultant company' +
      ' specializing in airline strategy, fleet planning, aircraft acquisition and aircraft financing. He is a' +
      ' Director of LATAM Airlines and Air Italy and has had significant experience in advising airlines,' +
      ' including Qatar Airways, on significant Merger and Acquisition projects within the airline industry. Giles' +
      ' Agutter has a degree in Aerospace Engineering from Manchester University.'
  },
  {
    id: 18,
    name: 'Jeff Samberg',
    role: 'BOARD MEMBER',
    avatar: JeffSamberg,
    description:
      'Jeff Samberg is the Managing Director of Acadia Woods Partners, LLC, a New York based investment partnership' +
      ' that focuses primarily on early-stage technology companies. Previously, he held a number of high-technology' +
      ' management roles, including Vice President of Corporate Strategy for PeopleSoft Inc., Vice President of Business Development' +
      ' for Wily Technology and Entrepreneur in Residence for Greylock Partners. Mr. Samberg received his MBA from' +
      ' Stanford University’s Graduate School of Business and his B.A. with high honors in economics from Princeton University.'
  },
  {
    id: 16,
    name: 'Millie Chou',
    role: 'Board Member',
    avatar: MillieChou,
    description:
      'Ms. Millie Chou serves as General Counsel of Downtown Project, Tony Hsieh’s effort to aid in the' +
      ' revitalization of Downtown Las Vegas. Downtown Project is investing $200 million in real estate, $50' +
      ' million in small businesses, $50 million in education, and $50 million in technology startups. Millie' +
      ' oversees the legal affairs of Downtown Project including contract negotiation and the other legal aspects' +
      ' of the company’s real estate portfolio, hospitality and food and beverage operations and small business' +
      ' investments.'
  }
];



// WEBPACK FOOTER //
// ./src/components/Leadership/leadership-data.js